<template>
  <v-app class="page">
    <v-container fluid class="fill-height" style="margin-bottom: 64px; margin-left: 28px; width: 98%">
      <!--   fila 1     -->
      <v-row>
        <v-col>
          <v-card height="100%" elevation="15" class="fill-width fill-height">
            <v-card-actions>
              <v-card-title class="card-title">{{ income.title }}
              </v-card-title>
              <v-spacer />
              <v-btn text v-on:click="onClickFilter(income)" class="filter-button" :rounded="true" variant="outlined">
                Filtrar
              </v-btn>
            </v-card-actions>

            <v-container>
              <v-chip style="background-color: transparent; border-color: #595959" v-for="(filter, i) in income.filters"
                :key="i" :close="filter.type !== 'platform'" @click:close="onClickRemoveTag(income, i)" class="chip"
                variant="outlined">
                {{ filter.selection.name }}
              </v-chip>
            </v-container>

            <v-card-text class="number" align="end">{{ income.incomes }}
            </v-card-text>
          </v-card>
        </v-col>

        <v-col>
          <v-card width="100%" height="100%" elevation="15" class="fill-width fill-height">
            <v-card-actions>
              <v-card-title class="card-title">{{ queryPerPatient.title }}
              </v-card-title>
              <v-spacer />
              <v-btn text @click="onClickFilter(queryPerPatient)" class="filter-button" :rounded="true"
                variant="outlined">
                Filtrar
              </v-btn>
            </v-card-actions>

            <v-container>
              <v-chip style="background-color: transparent; border-color: #595959"
                v-for="(filter, i) in queryPerPatient.filters" :key="i" :close="true"
                @click:close="onClickRemoveTag(queryPerPatient, i)" class="chip" variant="outlined">
                {{ filter.selection.name }}
              </v-chip>
            </v-container>

            <v-card-text class="number" align="end">{{
              Math.round(queryPerPatient.queryPerPatient * 100) + " de " + queryPerPatient.queryPerPatientRound * 100
              }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!--   fila 2     -->
      <v-row>
        <v-col>
          <v-card width="100%" height="100%" elevation="15" class="fill-width fill-height">
            <v-card-actions>
              <v-card-title class="card-title">{{ patient.title }}
              </v-card-title>
              <v-spacer />
              <v-btn text @click="onClickFilter(patient)" class="filter-button" :rounded="true" variant="outlined">
                Filtrar
              </v-btn>
            </v-card-actions>

            <v-container>
              <v-chip style="background-color: transparent; border-color: #595959"
                v-for="(filter, i) in patient.filters" :key="i" :close="true"
                @click:close="onClickRemoveTag(patient, i)" class="chip" variant="outlined">
                {{ filter.selection.name }}
              </v-chip>
            </v-container>

            <v-card-text class="number" align="end">{{ patient.patients }}
            </v-card-text>
          </v-card>
        </v-col>

        <v-col>
          <v-card width="100%" height="100%" elevation="15" class="fill-width fill-height">
            <v-card-actions>
              <v-card-title class="card-title">{{ appointment.title }}
              </v-card-title>
              <v-spacer />
              <v-btn text @click="onClickFilter(appointment)" class="filter-button" :rounded="true" variant="outlined">
                Filtrar
              </v-btn>
            </v-card-actions>

            <v-container>
              <v-chip style="background-color: transparent; border-color: #595959"
                v-for="(filter, i) in appointment.filters" :key="i" :close="filter.type !== 'platform'"
                @click:close="onClickRemoveTag(appointment, i)" class="chip" variant="outlined">
                {{ filter.selection.name }}
              </v-chip>
            </v-container>

            <v-card-text class="number" align="end">{{ appointment.appointments }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!--   fila 3     -->
      <v-row>
        <v-card width="100%" height="100%" elevation="15" class="ml-3 mr-3 fill-width fill-height">
          <v-card-actions>
            <v-card-title class="card-title">{{ surveys.title }}</v-card-title>
            <v-spacer />
            <v-btn @click="onClickFilter(surveys)" class="filter-button" text :rounded="true" variant="outlined">
              Filtrar
            </v-btn>
          </v-card-actions>

          <v-container>
            <v-chip style="background-color: transparent; border-color: #595959" v-for="(filter, i) in surveys.filters"
              :key="i" :close="true" @click:close="onClickRemoveTag(surveys, i)" class="chip" variant="outlined">
              {{ filter.selection.name }}
            </v-chip>
          </v-container>

          <v-container>
            <div style="display: flex; flex-direction: column">
              <div v-for="(review, index) in surveys.reviews" :key="index"
                style="display: inline-flex; align-items: center">
                <img :src="require('@/assets/img/arrow-right.svg')" style="padding: 10px" type="button"
                  @click="onClickReview(review)" alt="" />

                <img :src="require('@/assets/img/star.svg')" style="margin-left: 10px" alt="" />

                <div class="rating-number" style="margin-left: 6px">
                  {{ review.rating }}
                </div>

                <v-progress-linear style="width: 75%; margin-left: 20px; margin-right: 12px" :value="review.percentage"
                  height="12" :rounded="true" />

                <div class="rating-percentage" style="width: 50px; text-align: left">
                  {{ review.percentage }}%
                </div>

                <div class="review-count" style="width: 12%; margin-left: 20px; text-align: end; min-width: 150px;">
                  {{ review.count }}
                  {{ review.count === 1 ? "paciente" : "pacientes" }}
                </div>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-row>
    </v-container>

    <modal-filter :section="selectedSection" :show-dialog.sync="showFilterDialog" @close="onCloseFilterDialog" />

    <modal-survey-detail :section="selectedSection" :show-dialog.sync="showSurveyDialog" @close="onCloseSurveyDialog" />
  </v-app>
</template>

<style scoped lang="scss">
.review-count {
  color: #595959;
  font-size: 20px;
  font-family: Rubik;
  font-weight: 500;
  line-height: 36px;
  word-wrap: break-word;
}

.rating-percentage {
  color: #737373;
  font-size: 16px;
  font-family: Rubik;
  font-weight: 500;
  line-height: 24px;
  word-wrap: break-word;
}

.rating-number {
  color: #595959;
  font-size: 20px;
  font-family: Rubik;
  font-weight: 500;
  line-height: 36px;
  word-wrap: break-word;
}

.filter-button {
  height: 30px;
  margin-right: 10px;
  color: #595959;
  font-size: 14px;
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  line-height: 20px;
  word-wrap: break-word;
  text-transform: none;
  border: thin solid #595959;
}

.card-title {
  color: #262626;
  font-size: 20px;
  font-family: Rubik;
  font-weight: 600;
  line-height: 36px;
  word-wrap: break-word;
}

.chip {
  color: #737373;
  font-size: 14px;
  font-family: Plus Jakarta Sans;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  text-transform: none;
  border: thin solid #595959;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 5px;
}

.number {
  color: #595959;
  font-size: 64px;
  font-family: Rubik;
  font-weight: 500;
  word-wrap: break-word;
  margin-bottom: 24px;
}
</style>

<script>
import ModalFilter from "@/components/modals/ModalFilter/index.vue";
import ModalSurveyDetail from "@/components/modals/ModalSurveyDetail/index.vue";
import {
  getIncome,
  getReviews,
  getPatients,
  getAppointments,
  getQueryPerPatient
} from "@/store/modules/metrics";

export default {
  name: "metrics",
  components: { ModalSurveyDetail, ModalFilter },
  data: () => ({
    income: {
      type: "income",
      title: "Recaudación",
      incomes: "$ 0,00",
      filters: [
        { type: "platform", selection: { value: "ars", name: "Mercado Pago" } }
      ]
    },
    patient: {
      type: "patient",
      title: "Pacientes",
      patients: 0,
      filters: []
    },
    appointment: {
      type: "appointment",
      title: "Citas",
      appointments: 0,
      filters: [
        { type: "platform", selection: { value: "ars", name: "Mercado Pago" } }
      ]
    },
    queryPerPatient: {
      type: "queryPerPatient",
      title: "Promedio de consultas por paciente",
      queryPerPatient: 0,
      queryPerPatientRound: 0,
      filters: []
    },
    surveys: {
      type: "surveys",
      title: "Encuestas",
      filters: [],
      selectedReview: null,
      reviews: [
        { rating: 5, count: 0, percentage: 0 },
        { rating: 4, count: 0, percentage: 0 },
        { rating: 3, count: 0, percentage: 0 },
        { rating: 2, count: 0, percentage: 0 },
        { rating: 1, count: 0, percentage: 0 }
      ]
    },
    selectedSection: null,
    showFilterDialog: false,
    showSurveyDialog: false,
    status: ""
  }),
  async created() {
    this.updateSection(this.income);
    this.updateSection(this.patient);
    this.updateSection(this.appointment);
    this.updateSection(this.queryPerPatient);
    this.updateSection(this.surveys);
  },
  methods: {
    onClickFilter(section) {
      this.selectedSection = section;
      this.showFilterDialog = true;
    },

    onCloseFilterDialog() {
      this.updateSection(this.selectedSection);
      this.showFilterDialog = false;
      this.selectedSection = null;
    },

    onCloseSurveyDialog() {
      this.showSurveyDialog = false;
      this.selectedSection = null;
    },

    onClickReview(review) {
      if (review.count > 0) {
        this.surveys.selectedReview = review;
        this.selectedSection = this.surveys;
        this.showSurveyDialog = true;
      }
    },

    onClickRemoveTag(section, tagIndex) {
      section.filters.splice(tagIndex, 1);
      this.updateSection(section);
    },

    updateSection(section) {
      const request = {
        professional_id: null,
        speciality_id: null,
        month: null,
        year: null,
        patient_status: null,
        appointment_session: null,
        currency: null
      };

      for (let filter of section.filters) {
        switch (filter.type) {
          case "appointment_session":
            request.appointment_session = filter.selection.value;
            break;

          case "speciality":
            request.speciality_id = filter.selection.id;
            break;

          case "platform":
            request.currency = filter.selection.value;
            break;

          case "professional":
            request.professional_id = filter.selection.id;
            break;

          case "patient_status":
            request.patient_status = filter.selection.value;
            break;

          case "month":
            request.month = filter.selection.value;
            break;

          case "year":
            request.year = filter.selection.value;
            break;
        }
      }

      switch (section.type) {
        case "income":
          getIncome(request)
            .then(response => {
              let arsFormat = Intl.NumberFormat("es-AR", {
                style: "currency",
                currency: "ARS"
              });

              this.income.incomes = arsFormat.format(response.result);
            })
            .catch(error => {
              console.log(error);
            });
          break;

        case "patient":
          getPatients(request)
            .then(response => {
              this.patient.patients = response.result;
            })
            .catch(error => {
              console.log(error);
            });
          break;

        case "appointment":
          getAppointments(request)
            .then(response => {
              this.appointment.appointments = response.result;
            })
            .catch(error => {
              console.log(error);
            });
          break;

        case "queryPerPatient":
          getQueryPerPatient(request)
            .then(response => {
              this.queryPerPatient.queryPerPatient = response.result;
              this.queryPerPatient.queryPerPatientRound = Math.ceil(response.result);
            })
            .catch(error => {
              console.log(error);
            });
          break;

        case "surveys":
          getReviews(request)
            .then(response => {
              let totalPatients = 0;
              response.forEach(review => {
                totalPatients += review.total_patient;
              });

              this.surveys.reviews = [];
              response.forEach(review => {
                this.surveys.reviews.push({
                  rating: review.rating,
                  count: review.total_patient,
                  percentage:
                    (review.total_patient * 100) /
                    (totalPatients > 0 ? totalPatients : 1)
                });

                this.surveys.reviews.sort(function (a, b) {
                  return b.rating - a.rating;
                });
              });
            })
            .catch(error => {
              console.log(error);
            });
          break;
      }
    }
  }
};
</script>
